var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoupon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0361911 3.7915L0.812259 8.44365C0.99984 9.5681 1.61367 10.5308 2.51776 11.1958L12.9846 18.6504C14.1423 19.477 15.7298 19.2122 16.5564 18.0545L21.0203 11.8031C21.4245 11.2371 21.5567 10.5352 21.45 9.8958C21.3434 9.2564 20.9905 8.63542 20.4245 8.23128L9.95764 0.776708C9.03518 0.137435 7.92535 -0.130659 6.8009 0.0569211L2.14875 0.832989C0.737669 1.06838 -0.199204 2.38042 0.0361911 3.7915ZM8.32313 5.92164C8.48496 6.89175 7.82364 7.8179 6.85352 7.97973C5.8834 8.14156 4.95726 7.48024 4.79543 6.51012C4.6336 5.54001 5.29492 4.61387 6.26503 4.45203C7.23515 4.2902 8.16129 4.95152 8.32313 5.92164Z",
    fill: "#E8450A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/coupon.582c0bd5862409a5fe9ab4fca76a3c93.svg";
export { ForwardRef as ReactComponent };